export enum PostJobContent {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  LIVE = 'LIVE',
  NEW_PAGE = 'NEW_PAGE',
}

export type PostJobContentType = keyof typeof PostJobContent;
